import TemplateView from "../TemplateView"
import {getColorClassById, getStatusClassByType, getStatusTypeClassByColorId} from './utils'
import messageResource from '../messageResource'
import {WorkflowStatusType} from './constants'
import WorkflowStatusIcon from './WorkflowStatusIcon'

const WorkflowStatusPrefixKeyByType = {
    [WorkflowStatusType.OPEN]: 'workflow_status.prefix.open',
    [WorkflowStatusType.COMPLETED]: 'workflow_status.prefix.completed'
}

export default class WorkflowStatus extends TemplateView {
    constructor({
        onClickCb = () => {},
        name,
        type,
        colorId,
        showTypePrefix = false,
        showArrow = false,
        hideName = false,
    }) {
        super(null)
        this.params = {
            onClickCb,
        }

        this.state = {
            name: name,
            type: type,
            colorId: colorId,
            showTypePrefix: showTypePrefix,
            showArrow: showArrow,
            showName: !hideName,
        }

        this.onStatePropertyChanged('name', () => this._updateName())
        this.onStatePropertyChanged('showName', (show) => this.$name.toggle(show))
        this.onStatePropertyChanged('type', (type, prevType) => this._updateType(type, prevType))
        this.onStatePropertyChanged('colorId', (colorId, prevColorId) => this._updateColor(colorId, prevColorId))
        this.onStatePropertyChanged('showTypePrefix', () => this._updatePrefixClass())
        this.onStatePropertyChanged('showArrow', () => this._updateArrowClass())
        this.onAnyStatePropertyChanged(['colorId', 'type'], () => this._updateWorkflowStatusIconState())
    }

    _updateName() {
        this.$name.text(this.state.name)
    }

    _updateColor(colorId, prevColorId) {
        if (prevColorId) {
            this.getEl().removeClass(getColorClassById(prevColorId))
            this.getEl().removeClass(getStatusTypeClassByColorId(prevColorId))
        }
        if (colorId || colorId === 0) {
            this.getEl().addClass(getColorClassById(colorId))
            this.getEl().addClass(getStatusTypeClassByColorId(colorId))
        }
    }

    _updateType(type, prevType) {
        this._updateTypePrefix()
        if (prevType) this.getEl().removeClass(getStatusClassByType(prevType))
        if (type) this.getEl().addClass(getStatusClassByType(type))
    }

    _updateTypePrefix() {
        this.$typePrefix.text(messageResource.getMessage(WorkflowStatusPrefixKeyByType[this.state.type]))
    }

    _updatePrefixClass() {
        this.getEl().toggleClass('withPrefix', this.state.showTypePrefix)
    }

    _updateArrowClass() {
        this.getEl().toggleClass('showArrow', this.state.showArrow)
    }

    _updateWorkflowStatusIconState() {
        this.workflowStatusIcon.setState({
            colorId: this.state.colorId,
            type: this.state.type
        })
    }

    templateHtml() {
        return '<div class="workflowStatus">' +
               '    <div class="icon"></div>' +
               '    <div class="typePrefix"></div>' +
               '    <div class="name"></div>' +
               '</div>'
    }

    afterRender() {
        this.$name = this.find('.name')
        this.$typePrefix = this.find('.typePrefix')

        this.workflowStatusIcon = new WorkflowStatusIcon(null, {
            colorId: this.state.colorId,
            type: this.state.type
        }).init(this.find('.icon'))

        this.find('.typePrefix').toggle(this.state.showTypePrefix)
        this.getEl().on('click', (e) => this.params.onClickCb(e))

        this.renderInitialState()
    }
}


// WEBPACK FOOTER //
// ./web/js/workflowStatus/WorkflowStatus.js